import { TableOfContentsItem } from "@/models/table-of-contents";
import RequestMethod from "../models/client/RequestMethod";
import RestResponse from "../models/client/RestResponse";
import { RestClient } from "./restClient";

export type TocServiceType = {
  getTocByBlobId: (blobId: string) => RestResponse<TableOfContentsItem[]>;
};

const tocService = (client: RestClient, path: string): TocServiceType => ({
  getTocByBlobId: async (blobId: string) => {
    return await client.fetch<TableOfContentsItem[]>(
      RequestMethod.GET,
      `${path}/${blobId}`
    );
  },
});

export default tocService;
